(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dbs-native-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dbs-native-form')) {
 customElements.define('dbs-native-form', class extends HTMLElement {
  connectedCallback() {
   if (this.ready) return;
   this.ready = true;
   this.fields = [...this.querySelectorAll('.dbs-field')];
   this.form = this.closest('form');
   this.form.noValidate = true;
   this.step = 0;
   this.total = Math.ceil(this.fields.length / 2);
   this.next = this.querySelector('[data-next]');
   this.back = this.querySelector('[data-back]');
   this.submit = this.querySelector('[data-submit]');
   this.summary = this.querySelector('[data-summary]');
   const params = new URLSearchParams(location.search);
   this.querySelectorAll('[data-utm]').forEach(input => input.value = (params.get(input.dataset.utm) || '').slice(0,200));
   this.querySelector('[data-source-path]').value = location.origin + location.pathname;
   this.next.addEventListener('click', () => this.advance());
   this.back.addEventListener('click', () => { this.step = Math.max(0,this.step-1); this.draw(true); });
   this.form.addEventListener('submit', event => {
    if (this.step < this.total) { event.preventDefault(); this.advance(); return; }
    const invalid = this.fields.findIndex(field => !field.querySelector('input,select').checkValidity());
    if (invalid >= 0) { event.preventDefault(); this.step = Math.floor(invalid/2); this.draw(true); this.fields[invalid].querySelector('input,select').reportValidity(); }
   });
   this.draw(false);
  }
  advance() {
   for (const field of this.fields.slice(this.step*2,this.step*2+2)) {
    if (!field.querySelector('input,select').reportValidity()) return;
   }
   this.step = Math.min(this.total,this.step+1);
   this.draw(true);
  }
  draw(focus) {
   const done = this.step === this.total;
   this.fields.forEach((field,index) => field.hidden = Math.floor(index/2) !== this.step);
   this.summary.hidden = !done;
   this.next.hidden = done;
   this.submit.hidden = !done;
   this.back.hidden = this.step === 0;
   this.next.textContent = this.step === this.total-1 ? this.dataset.review : this.dataset.next;
   this.querySelector('[data-progress-label]').textContent = this.dataset.stepLabel.replace('{current}',Math.min(this.step+1,this.total)).replace('{total}',this.total);
   this.querySelector('[data-progress-bar]').style.width = `${Math.min((this.step+1)/this.total,1)*100}%`;
   if (done) {
    const list=this.summary.querySelector('dl'); list.replaceChildren();
    this.fields.forEach(field => { const dt=document.createElement('dt'),dd=document.createElement('dd'); dt.textContent=field.querySelector('label').textContent; dd.textContent=field.querySelector('input,select').value; list.append(dt,dd); });
   }
   if (focus) (done ? this.summary : this.fields[this.step*2].querySelector('input,select')).focus();
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
